import { render, staticRenderFns } from "./UserPlatform.vue?vue&type=template&id=69446d3d&scoped=true&"
import script from "./UserPlatform.vue?vue&type=script&lang=js&"
export * from "./UserPlatform.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69446d3d",
  null
  
)

export default component.exports